import api, {
  setHeaderToken,
  removeHeaderToken
} from '../../../apis/Api';

import router from '@/router'
import { allMixin } from "@/mixins/allMixin.js";

export default {
  namespaced: true,
  state: {
    profile: {},
  },
  getters: {
    getProfile(state) {
      return state.profile;
    },
  },
  mutations: {
    setProfile(state, payload) {
      state.profile = payload;
    },
  },
  actions: {
    updateProfile({
      state,
      commit,
      dispatch,
      rootGetters
    }, payload) {
      dispatch('setLoading', true)
      let token = localStorage.getItem("token");
      return new Promise((resolve, reject) => {
        api({
          method: payload.method,
          url: payload.url,
          data: payload.data,
          withCredentials: true,
          headers: {
            'Authorization': 'Bearer ' + token,
          }
        }).then((res) => {
          resolve(res)
          dispatch('setLoading', false)
        }).catch((err) => {
          console.log('authjs=err' + err)
          reject(err);
          dispatch('setLoading', false)
          return false
        })
      })
    },
    getProfile({ //blm dipake
      state,
      commit,
      dispatch,
      rootGetters
    }, payload) {
      dispatch('setLoading', true)
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: payload.url,
        params: payload.params,
        headers: {
          'Authorization': 'Bearer ' + token,
        }
      }).then((res) => {
        if (res.respond.status == "success") {
          commit("setProfile", res.respond.data);
        } else if (res.respond.status == "forbidden") {
          localStorage.removeItem("token")
          localStorage.removeItem("refreshToken")
          router.push(`/login`).catch(() => { });
        }
        dispatch('setLoading', false)
      }).catch((err) => {
        console.log('authjs=err' + err)
        dispatch('setLoading', false)
        return false
      })
    },
    getAccess({
      state,
      commit,
      dispatch,
      rootGetters
    }, payload) {
      dispatch('setLoading', true)
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: payload.url,
        params: payload.params,
        headers: {
          'Authorization': 'Bearer ' + token,
        }
      }).then((res) => {
        if (res.respond.status == "success") {
          commit("setProfile", res.respond.data);
        } else if (res.respond.status == "forbidden") {
          allMixin.methods.removeSession()
          router.push(`/login`).catch(() => { });
        }
        dispatch('setLoading', false)
      }).catch((err) => {
        console.log('authjs=err' + err)
        dispatch('setLoading', false)
        return false
      })
    },
    setLoading({
      commit
    }, payload) {
      commit("loader/setLoading", payload, {
        root: true,
      });
    },
  },
};